import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}]]

const IconRectangleVertical = createReactComponent('outline', 'rectangle-vertical', 'RectangleVertical', __iconNode);

export default IconRectangleVertical;